module.exports = __webpack_public_path__ + "static/media/Pet Adoption App Color.b6aa7df3.png";